/**
 * The variant id a CMS-authored form occupies in the lead-form variant registry.
 *
 * ─── Why a sentinel variant instead of editing every host ───────────────────────────
 * Seven widgets (About1/2/1037, Banner2/10, BlogWithLead1, Enrollments5) each resolve
 * `LEAD_DROP_FORM_SECTION_VARIANTS[variant]` themselves and then GATE their whole lead
 * column on that component existing. Teaching each one about custom forms would mean
 * seven near-identical edits, seven chances to get the fallback subtly different, and a
 * new widget added next month would silently miss the feature.
 *
 * So the custom form is registered as a variant like any other. Every host — current and
 * future — picks it up with no change at all: the map returns a component, the existing
 * guard passes, and the variant-6 special case simply does not match.
 *
 * `3005` matches `UNIVERSITY_SETTINGS_SECTION_TYPES.CUSTOM_FORM` on the server and sits in
 * the 3000+ custom range, so it can never collide with a real design variant.
 */
export const CUSTOM_LEAD_FORM_VARIANT = "3005";
